import moment from 'moment';

const formatDate = (date?: string) => {
  if (!date) return 'Não informado';
  const formatNewDate = moment(date).format('DD/MM/YYYY');
  if (formatNewDate === 'Invalid date') return '-';
  return formatNewDate;
};
export { formatDate };
